import { FC } from 'react'
import { Popover, PopoverBody, PopoverContent, PopoverProps, PopoverTrigger } from '@chakra-ui/react'
import { primaryColor } from 'theme/foundations/primaryColor'

import { InfoIcon } from 'components/SVGS'

type Props = PopoverProps & {
  size?: number
  popoverText: string
}

const InfoButton: FC<Props> = ({ popoverText, size = 7, ...props }) => {
  const { icon: { primaryIconColor, infoIconColor } } = primaryColor

  return (
    <Popover placement='top' variant={'responsive'} {...props}>
      {({ isOpen }) => (
        <>
          <PopoverTrigger>
            <span style={{ cursor: 'pointer' }}>
              <InfoIcon size={size} fill={isOpen ? primaryIconColor : infoIconColor} />
            </span>
          </PopoverTrigger>
          <PopoverContent bgSize={{ base: 'xs', md: 'md' }}>
            <PopoverBody>
              {popoverText}
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  )
}

export default InfoButton
